const EDITORIAL_CONTENT_PREFIX = "EditorialContent";

export const EDITORIAL_CONTENT_CLASSES = {
  header: `${EDITORIAL_CONTENT_PREFIX}-header`,
  mobileHeaderBox: `${EDITORIAL_CONTENT_PREFIX}-mobileHeaderBox`,
  grid: `${EDITORIAL_CONTENT_PREFIX}-grid`,
  masonry: `${EDITORIAL_CONTENT_PREFIX}-masonry`,
  masonryColumn: `${EDITORIAL_CONTENT_PREFIX}-masonryColumn`,
  masonryColumnLeft: `${EDITORIAL_CONTENT_PREFIX}-masonryColumnLeft`,
  masonryColumnRight: `${EDITORIAL_CONTENT_PREFIX}-masonryColumnRight`,
  masonryHeaderCell: `${EDITORIAL_CONTENT_PREFIX}-masonryHeaderCell`,
  masonrySourceOrder: `${EDITORIAL_CONTENT_PREFIX}-masonrySourceOrder`,
  gridItem: `${EDITORIAL_CONTENT_PREFIX}-gridItem`,
  gridItemLeft: `${EDITORIAL_CONTENT_PREFIX}-gridItemLeft`,
  gridItemRight: `${EDITORIAL_CONTENT_PREFIX}-gridItemRight`,
  gridItemLast: `${EDITORIAL_CONTENT_PREFIX}-gridItemLast`,
  gridItemLastOnMobile: `${EDITORIAL_CONTENT_PREFIX}-gridItemLastOnMobile`,
  gridItemHiddenOnMobile: `${EDITORIAL_CONTENT_PREFIX}-gridItemHiddenOnMobile`,
  title: `${EDITORIAL_CONTENT_PREFIX}-title`,
  subtitle: `${EDITORIAL_CONTENT_PREFIX}-subtitle`,
  linkDesktop: `${EDITORIAL_CONTENT_PREFIX}-linkDesktop`,
  linkMobile: `${EDITORIAL_CONTENT_PREFIX}-linkMobile`,
  ctaLinkButton: `${EDITORIAL_CONTENT_PREFIX}-ctaLinkButton`,
  gridWrapper: `${EDITORIAL_CONTENT_PREFIX}-gridWrapper`,
};

export const MOBILE_VISIBLE_ITEMS = 2;
export const MASONRY_COLUMNS = 2;
export const MASONRY_GUTTER = 10;
